<template>
  <div>
    <van-tabs v-model="activeTabIndex" sticky>
      <van-tab title="体格检查">
        <div class="table-wrapper">
          <table v-if="repData">
            <thead>
              <tr>
                <th class="item-name"><span class="td-content">体检编号</span></th>
                <th v-for="(examNo,index) in repData.examNumbers">
                  <div class="td-content">{{examNo}}</div>
                </th>
              </tr>
              <tr>
                <th class="item-name"><span class="td-content">体检日期</span></th>
                <th v-for="(examDate,index) in repData.examDates">
                  <div class="td-content">{{examDate}}</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <slot v-for='(cate,index) in categories1'>
                <tr class="cate-row">
                  <td :colspan="repData.count+1">
                    <span class="td-content">{{cate.categoryName}}</span>
                  </td>
                </tr>
                <tr v-for="(item,index) in cate.results" class="result-row">
                  <th class="item-name">
                    <span class="td-content">{{item.itemName}}</span>
                  </th>
                  <td class="item-result">
                    <span class="td-content"
                      :class="{higher:item.prompt1=='↑' || item.prompt1=='↑↑'|| item.prompt1=='*',lower:item.prompt1=='↓' }">{{item.value1}}</span>
                  </td>
                  <td class="item-result">
                    <span class="td-content"
                      :class="{higher:item.prompt2=='↑' || item.prompt2=='↑↑'|| item.prompt2=='*',lower:item.prompt2=='↓' }">{{item.value2}}</span>
                  </td>
                  <td class="item-result" v-if="repData.count>2">
                    <span class="td-content"
                      :class="{higher:item.prompt3=='↑' || item.prompt3=='↑↑'|| item.prompt3=='*',lower:item.prompt3=='↓' }">{{item.value3}}</span>
                  </td>
                  <td class="item-result" v-if="repData.count>3">
                    <span class="td-content"
                      :class="{higher:item.prompt4=='↑' || item.prompt4=='↑↑'|| item.prompt4=='*',lower:item.prompt4=='↓' }">{{item.value4}}</span>
                  </td>
                  <td class="item-result" v-if="repData.count>4">
                    <span class="td-content"
                      :class="{higher:item.prompt5=='↑' || item.prompt5=='↑↑'|| item.prompt5=='*',lower:item.prompt5=='↓' }">{{item.value5}}</span>
                  </td>
                </tr>
              </slot>
            </tbody>
          </table>
        </div>
      </van-tab>

      <van-tab title="检验项目">
        <div class="table-wrapper">
          <table v-if="repData">
            <thead>
              <tr>
                <th class="item-name"><span class="td-content">体检编号</span></th>
                <th v-for="(examNo,index) in repData.examNumbers">
                  <div class="td-content">{{examNo}}</div>
                </th>
              </tr>
              <tr>
                <th class="item-name"><span class="td-content">体检日期</span></th>
                <th v-for="(examDate,index) in repData.examDates">
                  <div class="td-content">{{examDate}}</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <slot v-for='(cate,index) in categories3'>
                <tr class="cate-row">
                  <td :colspan="repData.count+1">
                    <span class="td-content">{{cate.categoryName}}</span>
                  </td>
                </tr>
                <tr v-for="(item,index) in cate.results" class="result-row">
                  <th class="item-name">
                    <span class="td-content">{{item.itemName}}</span>
                  </th>
                  <td class="item-result">
                    <span class="td-content"
                      :class="{higher:item.prompt1=='↑' || item.prompt1=='↑↑'|| item.prompt1=='*',lower:item.prompt1=='↓' }">{{item.value1}}</span>
                  </td>
                  <td class="item-result">
                    <span class="td-content"
                      :class="{higher:item.prompt2=='↑' || item.prompt2=='↑↑'|| item.prompt2=='*',lower:item.prompt2=='↓' }">{{item.value2}}</span>
                  </td>
                  <td class="item-result" v-if="repData.count>2">
                    <span class="td-content"
                      :class="{higher:item.prompt3=='↑' || item.prompt3=='↑↑'|| item.prompt3=='*',lower:item.prompt3=='↓' }">{{item.value3}}</span>
                  </td>
                  <td class="item-result" v-if="repData.count>3">
                    <span class="content"
                      :class="{higher:item.prompt4=='↑' || item.prompt4=='↑↑'|| item.prompt4=='*',lower:item.prompt4=='↓' }">{{item.value4}}</span>
                  </td>
                  <td class="item-result" v-if="repData.count>4">
                    <span class="td-content"
                      :class="{higher:item.prompt5=='↑' || item.prompt5=='↑↑'|| item.prompt5=='*',lower:item.prompt5=='↓' }">{{item.value5}}</span>
                  </td>
                </tr>
              </slot>
            </tbody>
          </table>
        </div>
      </van-tab>

      <van-tab title="医技检查">
        <div class="image-report-wrapper">
          <div v-for='(cate,index) in categories2'>
            <div class="cate-name">{{cate.categoryName}}</div>
            <div v-for="(rep,i) in cate.imageReports " class="rep-container">
              <div class="rep-header">
                <span class="rep-name">{{rep.reportName}}</span><span class="rep-date">{{rep.examDate}}</span>
              </div>
              <pre class="rep-content">{{rep.reportConclusion}}</pre>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <!-- <div v-for="(cate,index) in repData.categories">
      <span>{{cate.categoryName}}</span>
    </div> -->
  </div>
</template>
<script>
  import headerNavbar from '../components/headerNavbar';
  import * as api_user from "@/api/user";
  import * as auth from "@/libs/auth";
  import * as api_report from "@/api/report";
  export default {
    components: {
      headerNavbar
    },
    data() {
      return {
        activeTabIndex: 0,
        userProfile: null,
        reports: null,
        report: null,
        processingReports: [],
        completedReports: [],
        selectedReports: [],
        repData: null,
        categories1: [],
        categories2: [],
        categories3: []
      };
    },
    mounted() {
      let tjbh = this.$route.query.tjbh;
      console.log(tjbh);
      api_report.getReportCompareData(tjbh).then(res => {
        this.repData = res.data;
        this.categories1 = this.repData.categories.filter((it) => {
          return it.categoryType == 0
        });

        this.categories2 = this.repData.categories.filter((it) => {
          return it.categoryType == 1
        });

        this.categories3 = this.repData.categories.filter((it) => {
          return it.categoryType == 2
        });
      });

    },
    //
    methods: {
      toggle(index) {
        this.$refs.checkboxes[index].toggle();
      },
      startCompare() {
        let tjbh = this.selectedReports.join(',');
        console.log(tjbh);
        this.$router.push({
          path: '/report/comparePage',
          query: {
            tjbh: tjbh
          }
        })
      },
    },
  };
</script>

<style lang="less" scoped>
  .table-wrapper {
    overflow-x: scroll;
    overflow-y: scroll;
    position: relative;
    z-index: 0;
    width: 100%;
    height: 100%;
  }

  table {
    table-layout: fixed;
    min-width: 100%;
    border-collapse: collapse;
    background-color: #fff;
  }

  table td {
    border: 1px solid #e6e6e6;
  }

  table th {
    border: 1px solid #e6e6e6;
    font-size: 14px;
  }

  /* 表头固定 */
  table thead th {
    position: sticky;
    top: 0;
    z-index: 4;
  }

  .cate-row {
    position: sticky;
    top: -3px;
    z-index: 3;
    width: 100%;
    left: 0;
    background-color: #f7f7f7;

    .td-content {
      padding: 8px;
      font-size: 16px;
      font-weight: 600;
      line-height: 40px;
      color: #3b3b3b;
      position: -webkit-sticky;
      position: sticky;
      left: 0;
      z-index: 3;
    }
  }

  .result-row {
    background-color: #ffffff;
  }

  .item-name {
    background-color: #F7F8FC;
    left: 0;
    position: sticky;
    z-index: 9;

    .td-content {
      display: flex;
      min-width: 90px;
      padding: 8px;
      text-align: left;
      font-size: 14px;
      font-weight: 600;
    }
  }

  .item-result {


    .td-content {
      padding: 8px;
      font-size: 14px;
      min-width: 90px;
      display: flex;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      align-items: center;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      flex-direction: column;
    }

    .higher {
      color: red;
    }

    .lower {
      color: blue;
    }
  }

  .image-report-wrapper {
    font-size: 14px;


    .cate-name {
      padding: 12px 8px;
      background-color: #f7f7f7;
      font-weight: 600;
      font-size: 16px;
    }

    .rep-container {
      margin-bottom: 6px;
      background-color: #ffffff;

      .rep-header {
        display: flex;
        border-bottom: 1px solid #e6e6e6;
        padding: 8px;

        .rep-name {
          flex: 1;
        }

        .rep-date {
          padding: 0 8px;
        }
      }

      .rep-content {
        padding: 8px;
        font-weight: 300;
        color: #909090;
        // 自动换行
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
      }
    }
  }
</style>